import { ProductInfoItemBase } from "abweb/dto/generated/product/ProductInfoItemBase";
export class ProductInfoItem extends ProductInfoItemBase {
  static createProductInfoItem(name, value) {
    const retVal = new ProductInfoItem();
    retVal.initProductInfoItem(name, value);
    return retVal;
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=ProductInfoItem.js.map
